import React, {Component} from 'react';
import 'assets/css/accueil.css';

/**
 * This function is called to display the footer.
 * @function Footer
 * @return {HTML} return the footer.
*/
class Footer extends Component {
  /**
   * This function is rendering the footer.
   * @function Footer
   * @return {HTML} return the footer.
  */
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <nav>
            <p className="text-center m-0 ceraPro text-white" style={{color: 'white', lineHeight: '2'}}>© {(new Date().getFullYear())} Have<span style={{color: '#ffdb09'}}>a</span>gooday - Made with love by IMPERIATEC ©</p></nav>
        </div>
      </footer>
    );
  }
}

export default Footer;
